import { useEffect } from 'react';

import { warmGoogleMapsAddressSearch } from '@/lib/googleMaps';

type IdleWindow = Window & {
  requestIdleCallback?: (
    callback: IdleRequestCallback,
    options?: IdleRequestOptions,
  ) => number;
  cancelIdleCallback?: (handle: number) => void;
};

export function GoogleMapsWarmup() {
  useEffect(() => {
    const idleWindow = window as IdleWindow;
    let idleHandle: number | null = null;
    let timeoutHandle: number | null = null;

    const warmAddressSearch = () => {
      void warmGoogleMapsAddressSearch();
    };

    if (idleWindow.requestIdleCallback) {
      idleHandle = idleWindow.requestIdleCallback(warmAddressSearch, { timeout: 1500 });
    } else {
      timeoutHandle = window.setTimeout(warmAddressSearch, 900);
    }

    return () => {
      if (idleHandle != null) {
        idleWindow.cancelIdleCallback?.(idleHandle);
      }

      if (timeoutHandle != null) {
        window.clearTimeout(timeoutHandle);
      }
    };
  }, []);

  return null;
}
